import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import classnames from 'classnames';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import { Impression } from '@nerdwallet/analytics/react/impression';

import { stringInputSpec } from '~/client/lib/editing-configs';
import AppStoreButton from './app-store-button';
import GooglePlayButton from './google-play-button';

import './app-buttons.less';

const DEFAULT_APP_STORE_URL =
  'https://nerdwallet.onelink.me/3687710914/2340937a';
const DEFAULT_GOOGLE_PLAY_URL =
  'https://nerdwallet.onelink.me/3687710914/b99e5635';

const AppButtons = ({ appStoreURL, className, googlePlayURL }) => {
  // impression IDs need to be unique but app buttons
  // don't have any uniquely identifying trait about them
  const idRef = React.useRef(uuid());

  return (
    <Impression
      eventType="element_impression"
      entityName="download_app_buttons"
    >
      <ElementImpression
        elementName="AppButtons"
        id={idRef.current}
        sectionCategory="lpc"
      >
        <div className={classnames(className, 'app-buttons')}>
          <AppStoreButton url={appStoreURL} />
          <GooglePlayButton url={googlePlayURL} />
        </div>
      </ElementImpression>
    </Impression>
  );
};

AppButtons.propTypes = {
  appStoreURL: PropTypes.string,
  className: PropTypes.string,
  googlePlayURL: PropTypes.string,
};

AppButtons.defaultProps = {
  appStoreURL: DEFAULT_APP_STORE_URL,
  className: '',
  googlePlayURL: DEFAULT_GOOGLE_PLAY_URL,
};

AppButtons.getEditingConfig = () => [
  stringInputSpec('appStoreURL', 'App store URL'),
  stringInputSpec('googlePlayURL', 'Google play store URL'),
];

AppButtons.displayName = 'AppButtons';

export default AppButtons;
